import { type EditorPlugin } from '../../types/aha-editor';
import DividerLineMarkdownPlugin from './DividerLineMarkdownPlugin';
import DividerLineSchemaPlugin from './DividerLineSchemaPlugin';
import DividerLine from './components/DividerLine';

export const DividerLineComponentPlugin: EditorPlugin = {
  name: 'Divider line Component Plugin',
  component: {
    type: 'divider-line',
    component: DividerLine,
  },
};

const DividerLinePlugin: EditorPlugin[] = [
  DividerLineSchemaPlugin,
  DividerLineComponentPlugin,
  DividerLineMarkdownPlugin,
];

export default DividerLinePlugin;
